import type { PropsWithChildren } from "react";

import { StyledAgentPromptCard, StyledAICaption } from "./styles";

type Props = PropsWithChildren;

const AIAgentPromptCard = ({ children }: Props) => (
    <StyledAgentPromptCard data-automation="ai-agent-prompt-card">
        {children}

        <StyledAICaption
            fontVariant="queryBar1"
            isInline
            shouldWrap={true}
        />
    </StyledAgentPromptCard>
);

export default AIAgentPromptCard;
